import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A user selects a target language in the first step of the Translate wizard',
  name: 'translation_language_selected',
  params: [
    {
      description: 'The language the user selected to translate the image into, e.g. "Spanish"',
      name: 'target_language',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
